import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCsrfToken } from "../services/authService";
import "../styles/Login.css";

export default function ForgotPassword() {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const csrf = await getCsrfToken();

      const response = await fetch("/api/auth/forgot-password", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          [csrf.headerName]: csrf.token,
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        setError(t("forgotPassword.error"));
        return;
      }

      setMessage(t("forgotPassword.success"));
      setEmail("");
    } catch {
      setError(t("forgotPassword.error"));
    }
  };

  return (
    <main className="login-page">
      <section className="login-card">
        <h1>{t("forgotPassword.title")}</h1>
        <p className="login-subtitle">{t("forgotPassword.subtitle")}</p>

        <form onSubmit={handleSubmit} className="login-form">
          <label>
            {t("forgotPassword.email")}
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </label>

          {message && <p className="login-success">{message}</p>}
          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="login-button">
            {t("forgotPassword.submit")}
          </button>
        </form>

        <div className="login-links">
          <Link to="/login">{t("forgotPassword.backToLogin")}</Link>
        </div>
      </section>
    </main>
  );
}